<template>
<div>
    <div class="flex items-center justify-between">
        <span class="flex-grow flex flex-col" id="toggleLabel">
            <span class="text-base md:text-sm font-medium text-gray-900">{{ label }}</span>
            <span class="hidden md:block text-sm leading-normal text-gray-500" v-if="description">{{ description}}</span>
        </span>


        <div class="mt-1 ml-4 flex rounded-md shadow-sm">
            <button @click="decreaseValue()" type="button"
                    class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                    :disabled="!canDecreaseValue"
                    :class="{'opacity-50': !canDecreaseValue()}"
            >
                <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                          clip-rule="evenodd"/>
                </svg>
            </button>
            <input v-model="localValue" type="tel" :name="name"
                   class=" focus:ring-blue-500 focus:border-blue-500 block w-10 sm:text-sm border-gray-300"
                   @focus="selectInputText"
            >
            <button @click="increaseValue" type="button"
                    class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                          clip-rule="evenodd"/>
                </svg>
            </button>
        </div>


    </div>
    <div class="block md:hidden pt-3">
        <span class="text-sm leading-normal text-gray-500" v-if="description">{{ description }}</span>
    </div>
</div>
</template>

<script>
export default {
    name: "NumberToggle",

    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(localValue) {
                this.$emit('input', localValue)
            }
        },
    },
    props: {
        value: {
            type: Boolean | Number,
            default: null
        },
        min: {},
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        decreaseValue() {
            if (!this.canDecreaseValue(this)) {
                return
            }
            this.localValue = parseInt(this.localValue) - 1
            this.$emit('change')
        },
        increaseValue() {
            this.localValue = parseInt(this.localValue) + 1

            this.$emit('change')
        },

        canDecreaseValue() {
            if (!this.localValue) {
                return false
            }
            if ((parseInt(this.localValue) - 1) < this.min) {
                return false
            }
            return true
        },
        selectInputText(e) {
            setTimeout(() => {
                e.target.select();
            }, 0);
        },
    },
}
</script>

<style scoped>

</style>
